import { render, staticRenderFns } from "./MNewsItem.vue?vue&type=template&id=f7d50af4&scoped=true"
import script from "./MNewsItem.vue?vue&type=script&lang=js"
export * from "./MNewsItem.vue?vue&type=script&lang=js"
import style0 from "./MNewsItem.vue?vue&type=style&index=0&id=f7d50af4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d50af4",
  null
  
)

export default component.exports